import {
  makeStyles,
  Button,
  CircularProgress,
} from "@material-ui/core";
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import { useEffect, useState } from "react";
import { ComparableProperty } from "../types";
import { PhotoGalleryModal } from "@roc/ui";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { PhotoGalleryByDateModal } from "./photoGalleryByDateModal";

const useStyles = makeStyles((theme) => ({

  button: {
    paddingBlock: "0px !important",
    height: "40px",
    width: "100%",
    backgroundColor: "#FFFFFF"
  },
}));

interface AllPropertyPhotosGalleryProps {
  buttonText?: string;
  property: ComparableProperty;
  buttonClassName?: string;
}


export const AllPropertyPhotosGallery = observer(({ buttonText = "See All Photos", property, buttonClassName }: AllPropertyPhotosGalleryProps) => {
  const classes = useStyles();
  const [photoGalleryByDateOpen, setPhotoGalleryByDateOpen] = useState(false);
  const [photoGalleryOpen, setPhotoGalleryOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolPhotosStore } = compToolStore;
  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryImagesGroupByDate, setGalleryImagesGroupByDate] = useState([]);

  const openDialogHandler = () => {
    if (galleryImagesGroupByDate?.length > 0) {
      setPhotoGalleryByDateOpen(true);
    } else {
      setPhotoGalleryOpen(true);
    }
  }

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        setIsLoading(true);
        await Promise.all([
          compToolPhotosStore.fetchAllCompPhotos(property),
          compToolPhotosStore.fetchAllCompPhotosGroupByDate(property)
        ]);
      } finally {
        setGalleryImages(compToolPhotosStore.getPropertyPhotos(property));
        setGalleryImagesGroupByDate(compToolPhotosStore.getPropertyPhotosGroupByDate(property));
        setIsLoading(false);
      }
      
    }

    fetchPhotos();
  }, [property, compToolPhotosStore]);

  return (
    <>
      <Button
        className={buttonClassName || classes.button}
        startIcon={isLoading ? <CircularProgress size={20} /> : <PhotoLibraryOutlinedIcon />}
        variant="outlined"
        color="primary"
        onClick={openDialogHandler}
        disabled={isLoading || (galleryImages?.length === 0 && galleryImagesGroupByDate?.length === 0)}
      >
        {buttonText}
      </Button>
      <PhotoGalleryByDateModal open={photoGalleryByDateOpen} onClose={() => setPhotoGalleryByDateOpen(false)} title={property?.data?.address} photos={galleryImagesGroupByDate} minZoomScale={1} enableZoom={true} />
      <PhotoGalleryModal open={photoGalleryOpen} onClose={() => setPhotoGalleryOpen(false)} title={property?.data?.address} photos={galleryImages} minZoomScale={1} enableZoom={true} />
    </>);
});